import { render } from "./General.vue?vue&type=template&id=65425489&ts=true&lang=pug"
import script from "./General.vue?vue&type=script&setup=true&lang=ts"
export * from "./General.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__